import { useCallback } from 'react';

const useUrlChange = ({ url }: { url: string }) => {
  return useCallback(async () => {
    const currentUrl = new URL(window.location.href);
    const pathnameParts = currentUrl.pathname.split('/');
    pathnameParts[pathnameParts.length - 1] = encodeURIComponent(url);
    const href = `${currentUrl.origin}${pathnameParts.join('/')}${currentUrl.search}${currentUrl.hash}`;
    const newUrl = new URL(href);
    newUrl.searchParams.set('href', url);
    window.location.href = newUrl.href;
  }, [url]);
};

export default useUrlChange;
